// Filter buttons for an employee picker (HR Policies "Send to"): role,
// department, region. Same rule as the PMO chart's Include: nothing selected
// in a group = all of it; OR within a group, AND across groups.

const GROUPS = [
  ["role", "Role", (u) => (u.role ? [u.role] : [])],
  ["department", "Department", (u) => (u.departments || []).map((d) => d.name)],
  ["region", "Region", (u) => (u.regions || []).map((r) => r.name)],
];

export const EMPTY_INCLUDE = { role: new Set(), department: new Set(), region: new Set() };

/** [[key, label, sortedValues]] for every group that has at least one value. */
export function filterOptions(users) {
  return GROUPS.map(([key, label, values]) => [
    key, label, [...new Set(users.flatMap(values))].sort((a, b) => a.localeCompare(b)),
  ]).filter(([, , opts]) => opts.length > 0);
}

export function filterEmployees(users, q, include) {
  const needle = (q || "").trim().toLowerCase();
  return users.filter((u) =>
    (!needle || (u.name || u.email || "").toLowerCase().includes(needle)) &&
    GROUPS.every(([key, , values]) => !include[key].size || values(u).some((v) => include[key].has(v))));
}
